import { render, staticRenderFns } from "./AffiliatePaymentTypeConfig.vue?vue&type=template&id=38531dfd&scoped=true"
import script from "./AffiliatePaymentTypeConfig.vue?vue&type=script&lang=js"
export * from "./AffiliatePaymentTypeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38531dfd",
  null
  
)

export default component.exports